module.exports = __webpack_public_path__ + "img/18.159a7f0f.jpg";